export const TOAST_DISPLAY_DURATION = 3000;
